'use client';
import React from 'react';

export type VirtualAgentType = 'balloon' | 'button' | 'transparent';
export interface VirtualAgentContextType {
  chatEnabled: boolean;
  setChatEnabled: (v: boolean) => void;
  appearance?: VirtualAgentType;
  chatWithUs?: boolean;
  defaultColor?: boolean;
}

const VirtualAgentContext = React.createContext<VirtualAgentContextType | null>(
  null
);

VirtualAgentContext.displayName = 'VirtualAgentContext';

export default VirtualAgentContext;
